import actionsTypes from '../constants/ActionsTypes';

const consultaExternaDefault = {
  id: null,
  numero: 1,
  endpointConsulta: '',
  campo: '',
  valor: '',
  login: '',
  senha: '',
  token: ''
};

const INITIAL_STATE = {
  corPrimaria: '#0040B9',
  corTextoPrimaria: '#fff',
  corSecundaria: '#FFCC29',
  corTextoSecundaria: '#333',
  paletaCorConteudo: 'default',
  aulaConfigsConsultasExternas: [consultaExternaDefault],
  fonte: 'Open Sans'
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionsTypes.SET_CONFIGS_LIVRO:
      return {
        ...state,
        corPrimaria: action.livro.cor_primaria ?? state.corPrimaria,
        corTextoPrimaria:
          action.livro.cor_texto_primaria ?? state.corTextoPrimaria,
        corSecundaria: action.livro.cor_secundaria ?? state.corSecundaria,
        corTextoSecundaria:
          action.livro.cor_texto_secundaria ?? state.corTextoSecundaria,
        paletaCorConteudo:
          action.livro.paleta_cor_conteudo ?? state.paletaCorConteudo,
        fonte: action.livro.fonte ?? state.fonte
      };
    default:
      return state;
  }
}
